import apiRequest from '../index'

export default {
  path: '/v1/maintenance_pack/subscriptions',
  async get (queryParameter) {
    await window.callNativeHTTPX()
    return apiRequest.get(this.path + queryParameter, {
      headers: {
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  },
  async post (authId, versionData, params) {
    await window.callNativeHTTPX()
    return apiRequest.post(`${this.path}`, { ...params }, {
      headers: {
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
        'APP-USERS-AUTH-ID': authId,
        'X-CLS-App-Version': versionData
      }
    })
  }
}
